import { render, staticRenderFns } from "./OrderComponents.vue?vue&type=template&id=bcdded60&"
import script from "./OrderComponents.vue?vue&type=script&lang=js&"
export * from "./OrderComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports